module.exports = __webpack_public_path__ + "img/256x256_circle_partial.85927c2d.svg";